import { createAsyncThunk } from '@reduxjs/toolkit';
import { FinancialMetricsApi } from 'api/FinancialMetricsApi';

export const createGetFinancialMetricsThunk = (api: FinancialMetricsApi) =>
  createAsyncThunk('financialMetrics/getFinancialMetrics', async (applicationId: string, thunkApi) => {
    try {
      const financialMetrics = await api.getFinancialMetrics(applicationId);
      return financialMetrics;
    } catch (error: any) {
      const payload = { ...(error.response?.data ?? {}), statusCode: error.responseStatus ?? 0 };
      return thunkApi.rejectWithValue(payload);
    }
  });
